// extracted by mini-css-extract-plugin
export default {"label":"UhOmjzGuLH8kkfcDlJXi","body":"mZUITuXCYlFqWMMnj42q","cancel":"HpFWdS_gUb1xUJa7yicA"};